import { render, staticRenderFns } from "./CustomerRequestedFileDetails.vue?vue&type=template&id=93dbf4e2&"
import script from "./CustomerRequestedFileDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerRequestedFileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QCardSection,QInput,QSelect,QField,QCheckbox,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QCardSection,QInput,QSelect,QField,QCheckbox,QSeparator,QCardActions})
